(function () {
  'use strict';

  var copyByTitle = {
    'questions fréquentes': 'Toutes les réponses à vos questions',
    'en savoir plus sur ce luminaire': 'Conseils, inspirations et idées pour intégrer ce luminaire chez vous.'
  };
  var observedRoots = new WeakSet();
  var documentObserver;

  function updatePanelCopy(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('.lf-panel-heading-copy h2').forEach(function (heading) {
      var title = (heading.textContent || '').trim().toLocaleLowerCase('fr');
      var copy = copyByTitle[title];
      if (!copy) return;
      var container = heading.closest('.lf-panel-heading-copy');
      var subtitle = container && container.querySelector('.lf-panel-subtitle');
      if (subtitle && subtitle.textContent.trim() !== copy) {
        subtitle.textContent = copy;
      }
    });
  }

  function attachToProductPanels() {
    var hosts = document.querySelectorAll('instant-layout');
    hosts.forEach(function (host) {
      var root = host.shadowRoot;
      if (!root) return;
      updatePanelCopy(root);
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
      new MutationObserver(function () {
        updatePanelCopy(root);
      }).observe(root, { childList: true, subtree: true, characterData: true });
    });
  }

  function start() {
    attachToProductPanels();
    if (!documentObserver) {
      documentObserver = new MutationObserver(attachToProductPanels);
      documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();